import { SvgIcon } from '@mui/material';

const Cross = (props) => {
    return (
        <SvgIcon
            width="12"
            height="12"
            viewBox="0 0 12 12"
            {...props}
            fill="#219653"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.46875 6L10.8438 2.65625C11.0312 2.46875 11.0312 2.125 10.8438 1.9375L10.0625 1.15625C9.875 0.96875 9.53125 0.96875 9.34375 1.15625L6 4.53125L2.625 1.15625C2.4375 0.96875 2.09375 0.96875 1.90625 1.15625L1.125 1.9375C0.9375 2.125 0.9375 2.46875 1.125 2.65625L4.5 6L1.125 9.375C0.9375 9.5625 0.9375 9.90625 1.125 10.0938L1.90625 10.875C2.09375 11.0625 2.4375 11.0625 2.625 10.875L6 7.5L9.34375 10.875C9.53125 11.0625 9.875 11.0625 10.0625 10.875L10.8438 10.0938C11.0312 9.90625 11.0312 9.5625 10.8438 9.375L7.46875 6Z"
                fill="white"
            />
        </SvgIcon>
    );
};
export default Cross;
